import { IconButton, Tooltip } from '@mui/material';
import { ButtonBaseOwnProps } from '@mui/material/ButtonBase/ButtonBase';
import { forwardRef } from 'react';
import { IEmoji } from 'src/@types/chat';
import { EmojiPickerPopover } from 'src/components/EmojiPickerPopover/EmojiPickerPopover';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

interface Props extends ButtonBaseOwnProps {
  onSelectEmoji: (emoji: IEmoji) => void;
  disabled?: boolean;
  arrow?: string;
  icon?: string;
  tooltipText?: string;
  isOpened?: (opened: boolean) => void;
}

export const EmojiPopover = forwardRef<any, Props>(
  (
    {
      onSelectEmoji,
      disabled = false,
      arrow = 'bottom-left',
      icon = 'bx:smile',
      tooltipText,
      isOpened,
      sx,
    },
    ref,
  ) => {
    const { translate } = useLocales();

    const tooltip = tooltipText || translate('shared.tooltip.add_reaction');

    if (disabled) {
      return (
        <IconButton size="small" disabled={disabled} sx={{ ...sx }}>
          <Iconify icon={icon} />
        </IconButton>
      );
    }
    return (
      <PopoverTrigger
        popover={EmojiPickerPopover}
        context={{
          onSelectEmoji: (emoji) => onSelectEmoji(emoji),
          arrow,
        }}
        isOpened={isOpened}
      >
        <Tooltip title={tooltip} arrow>
          <IconButton ref={ref} size="small" sx={{ ...sx }}>
            <Iconify icon={icon} />
          </IconButton>
        </Tooltip>
      </PopoverTrigger>
    );
  },
);
